import { Button, Dialog } from "@chakra-ui/react";
import { FC } from "react";

import { FONT_FAMILY } from "@assets/theme/foundations/textStyle";

interface ConfirmModalProps {
  heading: string;
  content: string;
  onClose: () => void;
  onSuccess: () => void;
  cancelBtnText?: string;
  successBtnText?: string;
}

const ConfirmModal: FC<ConfirmModalProps> = ({
  heading,
  content,
  onClose,
  onSuccess,
  cancelBtnText,
  successBtnText,
}) => {
  return (
    <>
      <Dialog.Header fontFamily={FONT_FAMILY.SECONDARY} fontSize={26}>
        {heading}
      </Dialog.Header>
      <Dialog.Body>{content}</Dialog.Body>
      <Dialog.Footer>
        <Button variant="secondary" onClick={onClose} mr={3}>
          {cancelBtnText}
        </Button>
        <Button variant="primary" onClick={onSuccess}>
          {successBtnText}
        </Button>
      </Dialog.Footer>
    </>
  );
};

export default ConfirmModal;
